import queryString from 'query-string';
import AdyenConfirmationRequest from 'src/adminPanel/entities/offsetting/adyenBatches/AdyenConfirmationRequest';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import callApi, { CallApiResult } from '.';

export const getAdyenBatches = (
    pageable: PageableQueryParams,
    batchNumber: any,
    confirmedState: any
): Promise<CallApiResult> => {
    let query = queryString.stringify(
        {
            ...pageable,
            batchNumber: batchNumber || undefined,
            confirmedState: confirmedState !== null || confirmedState != undefined ? confirmedState : undefined,
        },
        { skipEmpty: true, skipNull: true }
    );
    if (query !== '') query = '?' + query;
    return callApi(`/api/batch/adyen/list${query}`);
};

export const getAdyenBatchesByBatchNumber = (batchNumber: number) => {
    return callApi(`/api/batch/adyen/${batchNumber}/previewOrders`);
};

export const confirmAdyenBatch = (batchNumber: number, adyenConfirmationRequest: AdyenConfirmationRequest) => {
    return callApi(`/api/batch/adyen/${batchNumber}/confirm`, {
        method: 'POST',
        data: adyenConfirmationRequest,
    });
};
